export default "__VITE_ASSET__ofR63eRd__"